// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2M0LF","col":"styles_col__2JWJH"};